import { render, staticRenderFns } from "./mappingDomainManage.vue?vue&type=template&id=7cfd83ff&scoped=true"
import script from "./mappingDomainManage.vue?vue&type=script&lang=js"
export * from "./mappingDomainManage.vue?vue&type=script&lang=js"
import style0 from "./mappingDomainManage.vue?vue&type=style&index=0&id=7cfd83ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfd83ff",
  null
  
)

export default component.exports